<template>
  <div id="modalEditSkuPrice" class="modal fade" aria-hidden="true">
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical-center modal-lg"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="!canSubmit"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.库存商品成本价变动确认") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <div class="tx-gray-900 mg-b-15">
            {{ $t("product.当前库存SKU成本价发生变化，从")
            }}<span class="tx-danger"
              >【{{ Number(this.info.price).toFixed(2) }}】</span
            >{{ $t("product.变成为") }}
            <span class="tx-danger">
              【{{ Number(this.price).toFixed(2) }}】</span
            >，{{
              $t(
                "product.可能涉及以下采购单成本发生变化，请确认是否需要更新以下采购订单的库存商品成本价。"
              )
            }}
          </div>
          <table class="table table-striped mg-b-0">
            <thead>
              <tr>
                <td class="wd-250">
                  <label class="ckbox mg-b-0 d-inline-block valign-middle">
                    <input
                      type="checkbox"
                      :checked="isAll"
                      @change="changeAllCheck($event)"
                    />
                    <span></span>
                  </label>
                  {{ $t("product.订单编号") }}
                </td>
                <td class="wd-150">{{ $t("product.状态") }}</td>
                <td class="wd-100">{{ $t("product.SKU数量") }}</td>
                <td class="wd-150">{{ $t("product.SKU当前成本价") }}</td>
                <td class="wd-150">{{ $t("product.订单日期") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(order, index) in items" :key="index">
                <td class="valign-middle">
                  <label class="ckbox mg-b-0 d-inline-block valign-middle">
                    <input
                      type="checkbox"
                      :value="order.code"
                      v-model="checkArr"
                      :checked="order.checked"
                      :disabled="order.disabled"
                      @change="changeCheck(index)"
                    />
                    <span>{{ order.code }}</span>
                  </label>
                </td>
                <td class="valign-middle">
                  <div
                    class="tx-gray-600"
                    :class="order.status | orderStatusStyle"
                  >
                    {{ orderStatus[order.status] }}
                  </div>
                </td>
                <td class="valign-middle">
                  {{ order.quantity }}
                </td>
                <td class="valign-middle">
                  {{ order.costPrice ? order.costPrice : 0 }}
                </td>
                <td class="valign-middle">
                  {{ order.timeCreated }}
                </td>
              </tr>
              <tr v-if="items.length == 0">
                <td colspan="5" class="tx-center tx-16">
                  {{ $t("product.暂无采购单") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button
            :disabled="checkArr.length == 0"
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("product.修改选中订单成本价") }}
          </button>
          <button
            type="button"
            data-dismiss="modal"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
          >
            {{ $t("product.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "info", "price"],
  data() {
    return {
      canSubmit: true,
      items: [],
      checkArr: [],
      orderStatus: {
        1: this.$t("product.待审核"),
        2: this.$t("product.待配货"),
        3: this.$t("product.待发货"),
        4: this.$t("product.已发货"),
        5: this.$t("product.已完成"),
        6: this.$t("product.已取消"),
        7: this.$t("product.发货超时"),
        8: this.$t("product.部分发货"),
      },
    };
  },
  watch: {
    open: function () {
      this.getData();
    },
  },
  filters: {
    orderStatusStyle(val) {
      val = val - 0;
      let style = "";
      switch (val) {
        case 1:
        case 3:
        case 8:
          style = "tx-orange";
          break;
        case 4:
        case 5:
          style = "tx-success";
          break;
        case 6:
          style = "tx-gary";
          break;
      }
      return style;
    },
  },
  computed: {
    isAll() {
      let validArr = [];
      if (this.items.length > 0) {
        this.items.forEach((e, i) => {
          if (Number(e.costPrice) != Number(this.price)) {
            validArr.push(e);
          }
        });
      }
      return this.checkArr.length == validArr.length && this.checkArr.length > 0
        ? true
        : false;
    },
  },
  methods: {
    changeCheck(i) {
      this.$set(this.items[i], "checked", !this.items[i].checked);
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e, i) => {
          this.$set(e, "checked", false);
          this.$set(e, "disabled", false);
          if (Number(e.costPrice) == Number(this.price)) {
            this.$set(e, "disabled", true);
          } else {
            this.checkArr.push(e.code);
            this.$set(e, "checked", true);
          }
        });
      } else {
        this.items.forEach((e, i) => {
          this.$set(e, "checked", false);
        });
      }
    },
    goToOrder(code) {
      let routeData = this.$router.resolve({
        path: "purchase-order",
        query: { code: code },
      });
      window.open(routeData.href, "_blank");
    },
    getData() {
      this.canSubmit = false;
      this.items = [];
      this.checkArr = [];
      $.api_call(
        "api.SupplierProductStock.getOrders",
        {
          sku: this.info.sku,
        },
        (r) => {
          this.canSubmit = true;
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items = r.Data.Results;
            this.items.forEach((e, i) => {
              this.$set(e, "checked", false);
              this.$set(e, "disabled", false);
              if (Number(e.costPrice) == Number(this.price)) {
                this.$set(e, "disabled", true);
              } else {
                this.checkArr.push(e.code);
                this.$set(e, "checked", true);
              }
            });
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      );
    },
    save() {
      let param = {
        sku: this.info.sku,
        costPrice: this.price,
        codes: this.checkArr,
      };
      this.canSubmit = false;
      $.api_call("api.SupplierProductStock.syncOrdersCostPrice", param, (r) => {
        this.canSubmit = true;
        if (r.ErrorCode == "9999") {
          this.$emit("saveSuccess");
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
  },
};
</script>

